export interface DomainConfig {
  baseUrl: string;
  name: string;
}

export const DOMAIN_CONFIGS: Record<string, DomainConfig> = {
  'kahvediyari-dev-panel.whitelabelx.net': {
    baseUrl: import.meta.env.VITE_KAHVE_DIYARI_BASE_URL || 'https://api-kahvediyari-dev-panel.whitelabelx.net/api/v1/',
    name: 'Kahve Diyarı Dev',
  },
  'kahvediyari-panel.whitelabelx.net': {
    baseUrl: import.meta.env.VITE_KAHVE_DIYARI_BASE_URL || 'https://api-kahvediyari-panel.whitelabelx.net/api/v1/',
    name: 'Kahve Diyarı',
  },
  'whitelabel-dev-panel.azurewebsites.net': {
    baseUrl: import.meta.env.VITE_API_BASE_URL,
    name: 'Whitelabel Dev',
  },
  'whitelabel-prod-panel.azurewebsites.net': {
    baseUrl: import.meta.env.VITE_API_BASE_URL,
    name: 'Whitelabel Prod',
  },
  'walia-dev-panel.whitelabelx.net': {
    baseUrl: import.meta.env.VITE_WALIA_BASE_URL || 'https://api-walia-dev-panel.whitelabelx.net/api/v1/',
    name: 'Walia Coffee Dev',
  },
  'walia-panel.whitelabelx.net': {
    baseUrl: import.meta.env.VITE_WALIA_BASE_URL || 'https://api-walia-panel.whitelabelx.net/api/v1/',
    name: 'Walia Coffee',
  },
};

export function getCurrentDomain(): string {
  if (typeof window === 'undefined') return '';
  return window.location.hostname;
}

function resolveDomainKey(domain: string): string {
  if (DOMAIN_CONFIGS[domain]) return domain;

  if (domain.includes('kahvediyari')) {
    return domain.includes('dev') ? 'kahvediyari-dev-panel.whitelabelx.net' : 'kahvediyari-panel.whitelabelx.net';
  }

  if (domain.includes('walia')) {
    return domain.includes('dev') ? 'walia-dev-panel.whitelabelx.net' : 'walia-panel.whitelabelx.net';
  }

  if (domain.includes('whitelabel')) {
    return domain.includes('dev') ? 'whitelabel-dev-panel.azurewebsites.net' : 'whitelabel-prod-panel.azurewebsites.net';
  }

  return 'whitelabel-dev-panel.azurewebsites.net';
}

export function getCurrentDomainConfig(): DomainConfig {
  const domainKey = resolveDomainKey(getCurrentDomain());
  return DOMAIN_CONFIGS[domainKey];
}

export function getApiBaseUrl(): string {
  return getCurrentDomainConfig().baseUrl;
}

export function isKahveDiyariDomain(): boolean {
  return getCurrentDomain().includes('kahvediyari');
}

export function isWaliaCoffeeDomain(): boolean {
  return getCurrentDomain().includes('walia');
}

export function isWhitelabelDomain(): boolean {
  return getCurrentDomain().includes('whitelabel');
}

export function getDocumentTitle(): string {
  const domain = getCurrentDomain();

  switch (true) {
    case domain.includes('kahvediyari'):
      return 'Kahve Diyarı - Whitelabel X Panel';
    case domain.includes('walia'):
      return 'Walia Coffee - Whitelabel X Panel';
    case domain.includes('whitelabel'):
      return 'Whitelabel X Panel';
    default:
      return 'Whitelabel X Panel';
  }
}
